import { Lightning, Router, Utils } from "@lightningjs/sdk";
import { PlanRow, planText, planTextInset } from "core.components";
import { subscriptionOffers, SUBSCRIPTION_TERMS, } from "./subscriptionOffers";
const glow = (competition, name, x, y, w, h) => ({
    x,
    y,
    w,
    h,
    texture: Lightning.Tools.getSvgTexture(Utils.asset(`images/subscriptions/${competition}-glow-${name}.svg`), Math.ceil(w), Math.ceil(h)),
});
function subscriptionBackdrop(competition) {
    const ligue3 = competition === "ligue-3";
    const colour = ligue3 ? 0xff3a0412 : 0xff161616;
    return {
        Image: {
            x: ligue3 ? 501 : 471,
            y: ligue3 ? -76 : 0,
            w: ligue3 ? 2133 : 1993,
            h: ligue3 ? 1156 : 1080,
            src: Utils.asset(`images/subscriptions/${competition}-background.jpg`),
        },
        Shade: {
            x: ligue3 ? 491 : 471,
            w: 104.3,
            h: 1080,
            rect: true,
            color: colour,
        },
        Fade: {
            x: ligue3 ? 595.3 : 575.3,
            w: 938.7,
            h: 1080,
            rect: true,
            colorLeft: colour,
            colorRight: ligue3 ? 0x003a0412 : 0x00161616,
        },
        Glow: {
            w: 1179.725,
            h: 1080,
            clipping: true,
            alpha: ligue3 ? 1 : 0.8,
            renderToTexture: true,
            Large: glow(competition, "large", -144.88, -136.45, 976.892, 1385.797),
            Medium: glow(competition, "medium", -191.25, 36.39, 732.392, 1006.4),
            Small: glow(competition, "small", -237.62, 145.99, 639.65, 766.337),
        },
    };
}
export class Subscriptions extends Lightning.Component {
    static _template() {
        return {
            w: 1920,
            h: 1080,
            clipping: true,
            rect: true,
            color: 0xff161616,
            Scene: {
                Backdrop: subscriptionBackdrop("ligue-1"),
                Plans: { type: PlanRow, x: 115, y: 280 },
            },
            Tagline: {
                x: 115,
                y: 83 - planTextInset("Insatiable Display", 42),
                text: planText("Insatiable Display", 42, "SUBSCRIBE NOW TO ENJOY EVERY"),
            },
            Title: {
                x: 115,
                y: 116,
                text: Object.assign(Object.assign({}, planText("Insatiable Display", 100, "LIGUE 1+ MATCHES")), { textColor: 0xfffe80e0 }),
            },
            Logo: {
                x: 1634,
                y: 73,
                w: 171,
                h: 60,
                texture: Lightning.Tools.getSvgTexture(Utils.asset("images/navbar/ligue-1-plus.svg"), 342, 120),
            },
            Terms: {
                x: 115,
                y: 958 - planTextInset("Roboto Condensed", 18),
                text: Object.assign(Object.assign({}, planText("Roboto Condensed", 18, SUBSCRIPTION_TERMS)), { lineHeight: 23.4, w: 1198, wordWrapWidth: 1198 }),
            },
        };
    }
    set params({ competition }) {
        // Retain the original preview link as an alias for older demo URLs.
        const ligue3 = competition === "ligue-3" || competition === "supercoppa";
        const selected = ligue3 ? "ligue-3" : "ligue-1";
        this.patch({
            color: ligue3 ? 0xff3a0412 : 0xff161616,
            Scene: { Backdrop: subscriptionBackdrop(selected) },
            Title: {
                text: {
                    text: ligue3 ? "LIGUE 3 MATCHES" : "LIGUE 1+ MATCHES",
                    textColor: ligue3 ? 0xffd8c9a7 : 0xfffe80e0,
                },
            },
            Logo: {
                x: ligue3 ? 1723 : 1634,
                y: ligue3 ? 83 : 73,
                w: ligue3 ? 82 : 171,
                h: ligue3 ? 124 : 60,
                texture: Lightning.Tools.getSvgTexture(Utils.asset(ligue3
                    ? "images/subscriptions/ligue-3-logo.svg"
                    : "images/navbar/ligue-1-plus.svg"), ligue3 ? 164 : 342, ligue3 ? 248 : 120),
            },
        });
        this.tag("Scene.Plans").items = subscriptionOffers(selected);
        this._refocus();
    }
    _getFocused() {
        return this.tag("Scene.Plans");
    }
    _handleBack() {
        return true;
    }
    _handleBackRelease() {
        if (Router.getHistory().length)
            Router.back();
        else
            Router.navigate("home");
        return true;
    }
}
export default Subscriptions;
//# sourceMappingURL=Subscriptions.js.map